export type ExpenseMethod = 'at_cost' | 'standard_rate' | 'client_provided' | 'not_applicable';

export type StandardRateType = 'irs_mileage' | 'gsa_lodging';

export type ExpenseCategoryScope = 'all' | 'travel_only';

export interface ExpenseCategory {
  id: string;
  name: string;
  scope: ExpenseCategoryScope;
  method: ExpenseMethod;
  standardRateType?: StandardRateType;
  rate?: number | null;
  isCustom: boolean;
}

/** Which methods are available for a given category */
export interface ExpenseCategoryDefinition {
  id: string;
  name: string;
  defaultScope: ExpenseCategoryScope;
  defaultMethod: ExpenseMethod;
  standardRateAvailable: StandardRateType | null;
  icon?: string; // lucide icon name for UI
}

/** Current IRS standard mileage rate (2025) */
export const IRS_MILEAGE_RATE = 0.70;
